import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import {
  Grid,
  TextField,
  Button,
  Card,
  CardHeader,
  CardContent,
} from "@mui/material";

import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const FormFormData = ({
  errorObject,
  addProductForm,
  formData,
  handleChange,
  handleCheck,
  handleReset,
  handleSubmit,
  handleUpdate,
  ...props
}) => {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const { t, i18n } = useTranslation();
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage"),
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "form";

  return (
    <div className={classes.productPageTitle}>
      <div className="sw_makeStyles_tableContainer">
        <div className="d-flex justify-product mb-3">
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading text-center">
              <div className="sw_heading_title_inner">
                {DispensingLanguage[lan][menukey]["Form - Add/Edit"]}
              </div>
            </div>
          </Grid>
        </div>

        <Card className="sw_card">
          <CardHeader
            title={DispensingLanguage[lan][menukey]["Form Entry Form"]}
          />

          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={4} sm={4}>
                <TextField
                  variant="standard"
                  error={!!errorObject.DosageFormId}
                  helperText={errorObject.DosageFormId}
                  required
                  id="DosageFormId"
                  name="DosageFormId"
                  label={DispensingLanguage[lan][menukey]["Form Id"]}
                  value={formData.DosageFormId}
                  fullWidth
                  autoComplete="family-name"
                  inputProps={{ maxLength: 2 }}
                  onChange={(e) => handleChange(e)}
                  disabled={!addProductForm}
                />
              </Grid>

              <Grid item xs={8} sm={8}>
                <TextField
                  variant="standard"
                  disabled={!!props.permissionType}
                  error={!!errorObject.DosageFormName}
                  helperText={errorObject.DosageFormName}
                  required
                  id="DosageFormName"
                  name="DosageFormName"
                  label={DispensingLanguage[lan][menukey]["Form"]}
                  value={formData.DosageFormName}
                  fullWidth
                  autoComplete="family-name"
                  inputProps={{ maxLength: 50 }}
                  onChange={(e) => handleChange(e)}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        {/* Action buttons */}
        {addProductForm ? (
          <Grid container spacing={3}>
            <Grid item xs={12} className="mt-4 text-center">
              <Button
                disabled={!!props.permissionType}
                className="me-2"
                variant="contained"
                color="gray"
                type="reset"
                onClick={() => handleReset()}
              >
                {DispensingLanguage[lan][menukey]["Reset"]}
              </Button>
              <Button
                disabled={!!props.permissionType}
                className="me-2"
                variant="contained"
                color="primary"
                onClick={() => handleSubmit()}
              >
                {DispensingLanguage[lan][menukey]["Save"]}
              </Button>
              <Button
                className="me-2"
                variant="contained"
                color="gray"
                type="reset"
                onClick={() => props.history.push("/form")}
              >
                {DispensingLanguage[lan][menukey]["Cancel"]}
              </Button>
            </Grid>
          </Grid>
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12} className="mt-2 text-center">
              <Button
                disabled={!!props.permissionType}
                className="me-2"
                variant="contained"
                color="primary"
                onClick={() => handleUpdate()}
              >
                {DispensingLanguage[lan][menukey]["update"]}
              </Button>
              <Button
                className="me-2"
                variant="contained"
                color="gray"
                type="reset"
                onClick={() => props.history.push("/form")}
              >
                {DispensingLanguage[lan][menukey]["Cancel"]}
              </Button>
            </Grid>
          </Grid>
        )}
      </div>
    </div>
  );
};

export default FormFormData;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  tableContainer: {
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    padding: "2rem",
    color: "black",
  },
  fullWidth: {
    width: "100%",
  },
});
